import { t } from '@lingui/macro';
import { boolean, string, object } from 'yup';
const schema = object().shape({
    email: string()
        .email(t `This must be a valid email.`)
        .required(t `This is a required field.`),
    forceConvertDocument: boolean(),
    convertDocument: boolean().when('forceConvertDocument', {
        is: (forceConvertDocument) => forceConvertDocument,
        then: boolean().oneOf([true]),
        otherwise: boolean().oneOf([false]),
    }),
});
export default schema;
